/* eslint-disable max-len */

/**
 * Регулярное выражение для имени атрибута модели
 */
import { LINEBREAK } from '@technocom/common/platform';
import { ValidatorFn } from '@angular/forms';

/**
 * Регулярное выражение для проверки валидности URL
 */
export const URL_REGEX =
  'https?:\\/\\/(www\\.)?[-a-zA-Z0-9А-яёЁ@:%._\\+~#=]{1,256}\\.[-a-zA-Z0-9А-яёЁ()]{1,6}([-a-zA-Z0-9А-яёЁ()@:%_\\+.~#?&//=]*)';
export const URL_REGEX_HELP = 'Требуется валидный URL';
/**
 * Регулярное выражение для проверки валидности адреса электронной почты
 */
export const EMAIL_REGEX = /^([^@\s]+@[^@\s]+)?$/;
export const EMAIL_REGEX_HELP = 'требуется адрес в виде "название_ящика@имя_домена", без пробелов';

/**
 * Регулярное выражение для проверки валидности номера телефона
 */
export const PHONE_REGEX = /^((\+?\d+([ -]?\(\d{2,}\))?|\(\d{2,}\))([ -]?\d{2,})*)?$/;
export const PHONE_REGEX_HELP = 'допускаются только цифры, символы "+", "-", скобки и пробелы';
// регулярка на номера с добавочными
// /^((\+?\d+([ -]?\(\d{2,}\))?|\(\d{2,}\))([ -]?\d{2,})*( \(?[a-zа-я]+\.? ?(\d,? ?)+\)?)?)?$/i

/**
 * Регулярное выражение для проверки валидности ИНН юрлица или физлица и ИП
 */
export const INN_REGEX = /^((\d{10})|(\d{12}))?$/;
export const INN_REGEX_HELP = 'допускается 10 цифр (для юрлиц) или 12 цифр (для физлиц и ИП), без пробелов';
export const INN_MASK = '000000000000';

/**
 * Регулярное выражение для проверки валидности ИНН физлица или ИП
 */
export const PERSON_INN_REGEX = /^(\d{12})?$/;
export const PERSON_INN_REGEX_HELP = 'требуется 12 цифр, без пробелов';
export const PERSON_INN_MASK = '000000000000';

/**
 * Регулярное выражение для проверки валидности ИНН юрлица
 */
export const COMPANY_INN_REGEX = /^(\d{10})?$/;
export const COMPANY_INN_REGEX_HELP = 'требуется 10 цифр, без пробелов';
export const COMPANY_INN_MASK = '0000000000';

export const COMPANY_KPP_REGEX = /^((\d{4})([\dA-Z]{2})(\d{3}))?$/;
export const COMPANY_KPP_REGEX_HELP =
  'код в формате NNNNPPXXX (9 знаков), где' +
  LINEBREAK +
  'NNNN - код налогового органа (цифры),' +
  LINEBREAK +
  'PP - код причины постановки на учёт (цифры/заглавные латинские буквы),' +
  LINEBREAK +
  'XXX - порядковый номер постановки на учёт (цифры)';
export const COMPANY_KPP_MASK = '0000AA000';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export abstract class DateValidators {
  /**
   * Kendo `minValidator` из `kendo-angular-dateinputs` (переработан)
   */
  static min(minValue: Date): ValidatorFn {
    return ({ value }) => {
      if (!minValue || !value || value >= minValue) {
        return null;
      }

      return {
        minError: {
          minValue,
          value,
        },
      };
    };
  }
  /**
   * Kendo `maxValidator` из `kendo-angular-dateinputs` (переработан)
   */
  static max(maxValue: Date): ValidatorFn {
    return ({ value }) => {
      if (!maxValue || !value || value <= maxValue) {
        return null;
      }

      return {
        maxError: {
          maxValue,
          value,
        },
      };
    };
  }
}
